// ktore storeCode maja miec wlaczone artykuly blogowe
export default ['default', 'medicoverapteka']
